const initilaState = {
  loading: false,
  data: [],
};

export const R_getpreventivehealthcheckups = (state = initilaState, action) => {
  switch (action.type) {
    case "PREVENTIVE_CALL":
      return { ...state, loading: true };

    case "PREVENTIVE_STOP":
      return { ...state, loading: false };

    case "GET_PREVENTIVE":
      return { ...state, data: action.payload };

    default:
      return state;
  }
};
